export type FineSeverity = 'light' | 'medium' | 'serious' | 'very_serious';
export type FineStatus = 'pending' | 'driver_indicated' | 'contested' | 'paid' | 'cancelled';

export interface Fine {
  id: string;
  vehicleId: string;
  driverId: string | null;
  autoInfractionId: string | null;
  infractionCode: string | null;
  description: string;
  severity: FineSeverity;
  points: number;
  amountCents: number;
  discountAmountCents: number | null;
  infractionDate: string;
  notificationDate: string | null;
  dueDate: string | null;
  discountDueDate: string | null;
  location: string | null;
  status: FineStatus;
  source: string;
  indicatedDriverId: string | null;
  indicatedAt: string | null;
  indicationDeadline: string | null;
  indicationStatus: string | null;
  paidAt: string | null;
  paidAmountCents: number | null;
  notes: string | null;
  createdAt: string;
  vehicle?: { id: string; plate: string; brand: string | null; model: string | null } | null;
  driver?: { id: string; name: string; cpf: string; cnhCategory: string } | null;
  indicatedDriver?: { id: string; name: string; cpf: string; cnhCategory: string } | null;
}

export interface FinesListResponse {
  data: Fine[];
  meta: { page: number; limit: number; total: number };
}

export const SEVERITY_LABELS: Record<FineSeverity, string> = {
  light: 'Leve',
  medium: 'Média',
  serious: 'Grave',
  very_serious: 'Gravíssima',
};

export const SEVERITY_VARIANT: Record<FineSeverity, 'secondary' | 'warning' | 'destructive'> = {
  light: 'secondary',
  medium: 'warning',
  serious: 'destructive',
  very_serious: 'destructive',
};

export const STATUS_LABELS: Record<FineStatus, string> = {
  pending: 'Pendente',
  driver_indicated: 'Condutor indicado',
  contested: 'Contestada',
  paid: 'Paga',
  cancelled: 'Cancelada',
};

export const STATUS_VARIANT: Record<FineStatus, 'warning' | 'info' | 'success' | 'outline' | 'secondary'> = {
  pending: 'warning',
  driver_indicated: 'info',
  contested: 'secondary',
  paid: 'success',
  cancelled: 'outline',
};
